import { useState } from 'react';
import { ProjectSearchForm, ProjectSearchFilters } from './ProjectSearchForm';
import { AdminListPageWrapper } from '../../../AdminListPage';
import { ProjectResultsTable } from './ProjectResultsTable';
import { AdminSearch } from '@platform/client';
import { projectFiltersToQueryParams } from '../utils';
import { DownloadResultsModal } from '../DownloadResultsModal';

export const ProjectSearchPage = () => {
  const [filters, setFilters] = useState<ProjectSearchFilters>();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);

  return (
    <>
      {!filters && <ProjectSearchForm setFilters={setFilters} />}
      {filters && (
        <AdminListPageWrapper>
          <ProjectResultsTable
            filters={filters}
            setFilters={setFilters}
            setDownloadModalOpen={setDownloadModalOpen}
          />
        </AdminListPageWrapper>
      )}
      {downloadModalOpen && filters && (
        <ProjectDownloadModal filters={filters} onClose={() => setDownloadModalOpen(false)} />
      )}
    </>
  );
};

export const ProjectDownloadModal = ({
  filters,
  onClose,
}: {
  filters: ProjectSearchFilters;
  onClose: () => void;
}) => {
  const { data, isLoading, isError, isSuccess } = AdminSearch.useGetAdminSearchProjectExport(
    projectFiltersToQueryParams(filters),
  );

  return (
    <DownloadResultsModal
      onClose={onClose}
      rows={data?.projects ?? []}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      filenamePrefix='project_export'
    />
  );
};
